import styled from 'styled-components';
import * as colors from '~/config/colors';
import { Form } from '@unform/web';

export const ContainerForm = styled(Form)`
  display: flex;
  flex-direction: row;  
  @media (min-width: 890px) { //980
    width: 80rem;
    //height: 70rem;   
  }
  .Container__grupos {        
    //margin-top: 2px ;
  }
  .Container__nf_busca {    
    display: grid;
    grid-template-columns:  1fr   ;
    @media (min-width: 890px) { //980
      width: 80rem;  
      height: 9rem;    
    }       
    //border-radius: 3px;
    border: none;//0.1em solid #ccc;;
    //padding: 2px 0px; 
    padding: 5px 5px;
   // margin: 10px ;
    input {
        height: 1rem;  
        font-size: 1.3rem;       
        color : black;        
        letter-spacing: 1px;        
        text-align: left;  
        background: ${colors.CAMPO_INFORMACAO};    
    }
  }

  .Container__nf_dados {        
    display: grid;
    gap: 10px; 
    margin: 10px ;  
    @media (min-width: 890px) { //980
      display: grid;
      grid-template-columns: 1fr 1fr ;
      gap: 5px;         
      width: 80rem;  
      height: 25rem;        
      border: none;
      padding: 5px 5px; 
      margin: 5px ;      
    }
    input {
        height: 1rem;  
        font-size: 1.2rem;       
        color : ${colors.CAMPO_INFORMACAO_TEXTO};      
        letter-spacing: 1px;        
        text-align: right;
        background: ${colors.CAMPO_INFORMACAO_BACKGROUND};              
    }
  }

  .Container__nf_dados_grade {
    display: inline;    
    @media (min-width: 890px) { //980
      width: 80rem;  
     height: 25rem;  
    }    
    padding: 5px 5px; 
    margin: 5px ;
    /* z-index: 100; */
  }

  .Container__nf_dados_resumo {
    display: grid;
    grid-template-columns: 1fr 1fr  1fr;
    gap: 5px; 

    
    @media (min-width: 890px) { //980
      width: 80rem;  
      height: 8rem;    
    }  
    input {
        height: 1rem;  
        //font-weight: 600;
        font-size: 1.2rem;       
        color: ${colors.CAMPO_INFORMACAO_TEXTO};      
        letter-spacing: 1px;        
        text-align: right;
        background: ${colors.CAMPO_INFORMACAO_BACKGROUND};            
    }
    border: none;//0.1em solid #ccc;;    
    padding: 0px 5px; 
    margin: 2px ;
  }

//   .Container__info {         
//     input {
//         height: 1rem;  
//         background: ${colors.CAMPO_INFORMACAO};        
//     }
//   }

//   .Container__liberacao {          
//     input {
//         height: 1rem;  
//         font-size: 2rem;       
//         color : black;
//         font-weight: 900;
//         letter-spacing: 1px;
//         font-family:  'verdana, sans-serif';
//         text-align: center;
//         background: ${colors.CAMPO_INFORMACAO};       
//     }
//   }  
// `;


